import request from '@/API/';

export default {
  // Apps requests
  fetchApps: (payload) => {
    return request.get(`editor/apps?c=${payload.c}&q=${payload.q}`);
  },
  createApp: (payload) => {
    return request.post(`editor/${payload.clientHash}/apps`, {
      target_name: payload.appName,
    });
  },
  deleteUniqueApp: (payload) => {
    return request.delete(`editor/${payload.clientHash}/apps/${payload.appID}`);
  },
  copyApp: (payload) => {
    return request.post(`editor/${payload.clientHash}/apps/${payload.appID}`,{
      target_name: payload.appName,
    });
  },
  renameCurrentApp: (payload) => {
    return request.patch(`editor/${payload.clientHash}/apps/${payload.appID}/`, {
      target_name: payload.newAppName,
    });
  },
  // Interfaxces requests
  createInterface: (payload) => {
    return request.post(
      `editor/${payload.clientHash}/apps/${payload.appID}/interfaces/`, {
        target_name: payload.name,
        content: payload.content,
      },
    );
  },
  createNewEnvironment: (payload) => {
    return request.post(
      `editor/${payload.clientHash}/apps/${payload.appID}/environments/`, {
        target_name: payload.name,
      },
    );
  },
  deleteInterface: (payload) => {
    return request.delete(`editor/${payload.clientHash}/apps/${payload.appID}/interfaces/${payload.interface.hash}`);
  },
  copyInterface: (payload) => {
    return request.post(`editor/${payload.clientHash}/apps/${payload.appHash || payload.appID }/interfaces/${payload.interface.hash}`, {
      target_name: payload.interface.real_name,
      target_app: payload.targetApp ? payload.targetApp : ""
    });
  },
  copyEnvironment: (payload) => {
    return request.post(`editor/${payload.clientHash}/apps/${payload.appHash || payload.appID }/environments/${payload.interface.hash}`, {
      target_name: payload.interface.real_name,
      target_app: payload.targetApp ? payload.targetApp : ""
    });
  },
  renameCurrentInterface: (payload) => {
    return request.patch(`editor/${payload.clientHash}/apps/${payload.appID}/interfaces/${payload.interface.hash}`, {
      target_name: payload.newInterfaceName,
    });
  },
  renameCurrentEnvironment: (payload) => {
    return request.patch(`editor/${payload.clientHash}/apps/${payload.appID}/environments/${payload.interface.hash}`, {
      target_name: payload.newInterfaceName,
    });
  },
  toggleInterface: (payload) => {
    const status = payload.newStatus ? 'enable' : 'disable';
    return request.put(`editor/${payload.clientHash}/apps/${payload.appID}/interfaces/${payload.interface.hash}/${status}`);
  },
};
